export default __webpack_public_path__ + "static/media/collectionBbanner.1bc9300b.png";